<template>
    <div>
        <div id="header" class="header" @mouseover="mouseover" @mouseleave="mouseleave">
            <img v-show="isHoverHeader" class="head-logo" style="height: 62px;"
                :src="require('@/assets/logo-primary.png')" @click="uigo('/')" />
            <img v-show="!isHoverHeader" class="head-logo" style="height: 62px;"
                :src="require('@/assets/logo-white.png')" />
            <div class="item-service-list">
                <div v-for="(item, index) in itemServiceList" :key="index" class="item-service">
                    <div class="item-service-text" :alwayshover="issetHoverHeader">
                        {{ item.name }}
                    </div>
                    <div class="item-service-expand">
                        <div style="display: flex; justify-content: center;white-space: nowrap;">
                            <div style="font-size: 30px;font-weight: bold;color: #333;">
                                {{ item.name }}
                            </div>
                            <div style="font-size: 15px;margin-left: 100px;text-align: left;">
                                <div v-for="(item2, index2) in item.itemlist" :key="index2" class="expand-subtext"
                                    @click="uigo(item2.link)">
                                    {{ item2.name }}
                                </div>
                            </div>
                            <div class="item-service-expand-imgblock">
                                <img class="item-service-expand-img" :src="item.swiperimg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-service">
                    <div class="item-service-text" :alwayshover="issetHoverHeader" @click="uigo('chatour')">
                        联系我们
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机端样式 -->
        <div id="m-header" class="m-header">
            <div>
                <div class="menu2">
                </div>
                <img class="head-logo" :src="require('@/assets/logo-primary.png')" @click="uigo('/')" />
                <div class="menu" @click="showNav()">
                    <div ref="menu-1"></div>
                    <div ref="menu-2"></div>
                    <div ref="menu-3"></div>
                </div>
            </div>
            <!-- 路由导航 -->
            <div refs="m-header-nav" :class="isShowNav ? 'm-header-nav500' : 'm-header-nav'">

                <div v-for="(item, index) in itemServiceList" class="m-header-nav-item" :key="index">
                    <div class="m-header-nav-item-title">{{ item.name }}</div>
                    <div v-for="(item2, index2) in item.itemlist" class="m-header-nav-item-sub" :key="index2"
                        @click="uigo(item2.link)">
                        {{ item2.name }}
                    </div>
                </div>
                <div class="m-header-nav-item">
                    <div class="m-header-nav-item-title" @click="uigo('chatour')">联系我们</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderView',
    data() {
        return {
            computedHeight: "",
            isShowNav: false,
            isHoverHeader: false,
            issetHoverHeader: false,
            itemServiceList: [
                {
                    name: '产品欣赏',
                    swiperimg: 'http://nas.kingbox999.com/file/jpg/7676a985cba31838e8c3e6fd6baf8f38.jpg',
                    link: null,
                    itemlist: [
                        {
                            name: '5G黄金', link: '/productlist'
                        },
                        {
                            name: '3D黄金', link: '/productlist'
                        },
                        {
                            name: '古法金', link: '/productlist'
                        },
                        {
                            name: '精品黄金', link: '/productlist'
                        }
                    ]
                },
                {
                    name: '今日金价',
                    swiperimg: 'http://nas.kingbox999.com/file/jpg/46eed06cea851b7b39d4bab5237fe8b0.jpg',
                    link: null,
                    itemlist: [
                        // {
                        //     name: '预约到店', link: ''
                        // },
                        // {
                        //     name: '免费售后服务', link: '/freeservices'
                        // },

                        {
                            name: '今日金价', link: '/goldprice'
                        },
                        {
                            name: '商品检验', link: '/checkproduct'
                        },
                    ]
                },
                // {
                //     name: '会员专区',
                //     swiperimg: 'http://nas.kingbox999.com/file/jpg/7676a985cba31838e8c3e6fd6baf8f38.jpg',
                //     link: null,
                //     itemlist: [
                //         // {
                //         //     name: '入会指引', link: '/memberarea'
                //         // },
                //         {
                //             name: '会员权益', link: '/memberbenefits'
                //         },
                //         // {
                //         //     name: '异业合作', link: '/crosscooperation'
                //         // },
                //         // {
                //         //     name: 'FAQ', link: ''
                //         // }
                //     ]
                // },
                {
                    name: '关于品牌',
                    swiperimg: 'http://nas.kingbox999.com/file/jpg/d5703880ba683705acc4c11a455e0064.jpg',
                    link: null,
                    itemlist: [
                        {
                            name: '品牌简介', link: '/brandintroduction'
                        },
                        {
                            name: '品牌历程', link: '/brandhistory'
                        },
                        {
                            name: '门店形象', link: '/storeimage'
                        },
                        {
                            name: '直营门店', link: '/storelist'
                        },

                    ]
                },
                // {
                //     name: '联系我们',
                //     swiperimg: 'http://nas.kingbox999.com/file/jpg/8437a6ff6e9b27699f6bed8e08177909.jpg',
                //     link: 'chatour',
                //     // itemlist: [
                //     //     {
                //     //         name: '招商加盟', link: '/investment'
                //     //     },
                //     //     {
                //     //         name: '招聘', link: '/recruitment'
                //     //     }
                //     // ]
                // },
                // {
                //     name: '联系我们',
                //     swiperimg: require('@/assets/home-swiper1.jpg'),
                //     link: null,
                //     itemlist: [
                //         {
                //             name: '企业邮箱', link: ''
                //         },
                //         {
                //             name: '企业微信', link: ''
                //         }
                //     ]
                // }
            ]
        }
    },
    created() {

    },
    methods: {
        showNav() {
            if (!this.isShowNav) {
                this.isShowNav = !this.isShowNav
                // console.log(document.getElementsByClassName('m-header-nav'))

                // document.getElementsByClassName('m-header-nav')[0].style.display = 'block'
                // document.getElementsByClassName('m-header-nav')[0].style.height = 'auto'

                // this.$refs['m-header-nav'].style.display = 'block'
                // this.$refs['m-header-nav'].style.height = 'auto'

                this.$refs['menu-1'].style.transform = 'rotate(45deg) translate(5px, 10px)'
                this.$refs['menu-2'].style.transform = 'rotate(90deg)  translate(1px, 2px)'
                this.$refs['menu-2'].style.opacity = '0'
                this.$refs['menu-3'].style.transform = 'rotate(-45deg) translate(2px, -8px)'
            } else {
                this.isShowNav = !this.isShowNav
                // this.$refs['m-header-nav'].style.height = '0'
                // // this.$refs['m-header-nav'].style.display = 'none'
                // document.getElementsByClassName('m-header-nav')[0].style.height = '0'
                // document.getElementsByClassName('m-header-nav')[0].style.display = 'none'


                this.$refs['menu-1'].style.transform = 'rotate(0deg) translate(0px, 0px)'
                this.$refs['menu-2'].style.transform = 'rotate(0deg)  translate(0px, 0px)'
                this.$refs['menu-2'].style.opacity = '1'
                this.$refs['menu-3'].style.transform = 'rotate(0deg) translate(0px, 0px)'
            }
        },
        mouseover() {
            this.isHoverHeader = true
        },
        mouseleave() {
            this.issethover()
        },
        issethover() {
            if (this.issetHoverHeader) return
            this.isHoverHeader = !this.isHoverHeader
        },
        uigo(link) {
            if (link == '') {
                return
            }
            this.$router.push(link)
        },
        hoverHeader() {
            this.issetHoverHeader = true
            this.isHoverHeader = true

        },
    }
}

</script>

<style scoped>
/*手机端*/
@media screen and (max-width: 767px) {
    .m-header-nav {
        display: block;
        overflow: hidden;
        height: 0px;
        width: 100%;
        transition: 0.5s;
    }

    .m-header-nav500 {
        display: block;
        overflow: hidden;
        height: 588px;
        width: 100%;
        transition: 0.5s;
    }

    #header {
        display: none;
        overflow: hidden;
    }

    .m-header {
        z-index: 999;
        position: relative;
    }

    .m-header>:first-child {
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #ffffff;
        z-index: 100;
    }

    .head-logo {
        height: 42px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .menu {
        margin-right: 20px;
        height: 82px;
        display: flex;
        align-content: center;
        max-width: 28px;
        flex-wrap: wrap;
    }

    .menu>div {
        height: 4px;
        width: 28px;
        background-color: #333;
        margin-top: 5px;
        transition: all 0.5s ease;
    }

    .menu2 {
        width: 28px;
        margin-left: 20px;
        height: 82px;
        display: flex;
        align-content: center;
        max-width: 28px;
        flex-wrap: wrap;
    }

    .m-header-nav-item {
        color: #646464;
        font-size: 14px;
        background-color: rgb(247, 247, 247);
    }

    .m-header-nav-item-title {
        padding-left: 25px;
        height: 40px;
        line-height: 40px;
        border-bottom: 2px solid #dadada;
    }

    .m-header-nav-item-sub {
        height: 40px;
        height: 40px;
        line-height: 40px;
        border-bottom: 2px solid #dadada;
        margin-left: 50px;
    }
}

/* 电脑端样式，当视口宽度大于等于 768px 时应用 */
@media screen and (min-width: 768px) {
    #m-header {
        display: none;
        overflow: hidden;
    }


}

.header {
    text-align: center;
    width: 100%;
    color: #ffffff;
    transition: all 0.2s ease;
}

.head-logo {
    margin-top: 20px;
    cursor: pointer;
}

.item-service-list {
    font-size: 13px;
    margin: 0 20%;
    margin-top: 10px;
    display: flex;
    justify-content: space-evenly;
}

.item-service-text {
    cursor: pointer;
    padding-bottom: 10px;
}

.item-service-text[alwayshover=true] {
    color: #333333;
}


.item-service-text:hover,
.goldprice:hover {
    color: #D4A92A;
}

.item-service-text+.item-service-expand {
    display: block;
    height: 0px;
    transition: all 1s ease;
    /*强制GPU加速*/
    transform: translateZ(0);
}

.item-service-text:hover+.item-service-expand {
    padding-top: 70px;
    padding-bottom: 70px;
    display: block;
    height: auto;
    transition: all 0.2s cubic-bezier(0, 0, 0.52, 1.49);
    /*强制GPU加速*/
    transform: translateZ(0);
    z-index: 100;
    opacity: 1;
}

.goldprice {
    position: absolute;
    right: 30px;
    top: 30px;
    font-size: 13px;
    color: #ffffff;
}

.header:hover {
    background-color: white;
    color: #333 !important;
    transition: all 0.2s ease;
}


.item-service-expand {
    display: none;
    position: absolute;
    margin-top: 10px;
    margin-bottom: 0px;
    width: 100vw;
    top: 112px;
    left: 0;
    background-color: #fafafa;
    height: 0px;
    opacity: 0;
    /* 初始高度为0 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    transition: all 0.2s cubic-bezier(0, 0, 0.52, 1.49);
    z-index: -100;
}

.item-service-expand:hover {
    display: block;
    height: auto;
    padding-top: 70px;
    padding-bottom: 70px;
    transition: all 0.2s cubic-bezier(0, 0, 0.52, 1.49);
    opacity: 1;
    z-index: 100;

}

.expand-subtext {
    font-size: 13px;
    padding: 6px 0;
    color: #333;
    cursor: pointer;
}

.expand-subtext:hover {
    padding: 6px 0;
    color: #D4A92A;

}

.item-service-expand-imgblock {
    border-left: 1px solid #eeeae3;
    padding-left: 80px;
    margin-left: 80px;
    width: 20%;
}

.item-service-expand-img {
    width: 100%;
    height: auto;
    max-width: 100%;
}
</style>